import { Injectable } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';

@Injectable()
export class ElDirectionality extends Directionality {}
